import { Link } from "react-router-dom";

import Badge from "../../../Badge";
import Reveal from "../../Reveal";
import { howItWorksSections } from "../../../../content/howItWorksSections";

/**
 * Centered landing hero for the standalone "How It Works" operations page.
 * Translation: Centered landing hero for the standalone "How It Works" operations page.
 *
 * @param {Object} props - Hero props.
 * @param {React.RefObject} props.heroRef - Ref used by the layout to toggle the sticky nav.
 * @returns {JSX.Element} Hero section.
 */
const Hero = ({ heroRef }) => {
  const { hero } = howItWorksSections;

  return (
    <header id="top" ref={heroRef} className="hiw-hero">
      <div className="section-shell">
        <Reveal>
          <Badge className="hiw-hero__badge">{hero.badge}</Badge>
          <h1 className="hiw-hero__title">
            {hero.titleMain}
            <span className="text-accent">{hero.titleAccent}</span>
          </h1>
          <p className="hiw-hero__lede">{hero.description}</p>

          <div className="cta-row hiw-hero__actions">
            <Link className="button button-primary" to={hero.primaryCta.href}>
              {hero.primaryCta.label}
            </Link>
          </div>
        </Reveal>
      </div>
    </header>
  );
};

export default Hero;
